import { PathStopAPI } from '../../../api/datamanager/PathStopAPI';

export class PathStopsCommand {
    getByPath(edition, pathId, providerId, successCallback, errorCallback) {
        const apiResult = PathStopAPI.listByPath(edition.network, pathId, providerId);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    save(edition, pathStop, successCallback, errorCallback) {
        let apiResult = undefined;
        let successMessage = "";

        if (undefined === pathStop.id || 0 === pathStop.id) {
            apiResult = PathStopAPI.create(edition.network, [pathStop]);
            successMessage = "Paragem do Percurso criada com sucesso";
        }
        else {
            apiResult = PathStopAPI.update(edition.network, pathStop.id, pathStop);
            successMessage = "Paragem do Percurso editada com sucesso";
        }
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                const output = {
                    message: successMessage,
                    data: undefined
                };

                try { output.data = JSON.parse(result); }
                catch (_) { }

                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    createInBulk(edition, pathStops, successCallback, errorCallback) {
        const apiResult = PathStopAPI.create(edition.network, pathStops);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                const output = {
                    message: "Paragens do Percurso criados com sucesso",
                    data: undefined
                };

                try { output.data = JSON.parse(result); }
                catch (_) { }

                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    updateInBulk(edition, pathStops, successCallback, errorCallback) {
        const apiResult = PathStopAPI.updateList(edition.network, pathStops);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                const output = {
                    message: "Paragens do Percurso alterados com sucesso",
                    data: undefined
                };

                try { output.data = JSON.parse(result); }
                catch (_) { }

                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    updateSpine(edition, pathStopId, isInSpine, successCallback, errorCallback) {
        const apiResult = PathStopAPI.updateSpine(edition.network, pathStopId, isInSpine);
        apiResult.then(() => {
            if (undefined !== successCallback) {
                successCallback();
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    updateSpineInBulk(edition, pathStopIds, isInSpine, successCallback, errorCallback) {
        const apiResult = PathStopAPI.updateSpineInBulk(edition.network, pathStopIds, isInSpine);
        apiResult.then(() => {
            if (undefined !== successCallback) {
                successCallback();
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    updateComplementaryTerminal(edition, pathStopId, isComplementaryTerminal, successCallback, errorCallback) {
        const apiResult = PathStopAPI.updateComplementaryTerminal(edition.network, pathStopId, isComplementaryTerminal);
        apiResult.then(() => {
            if (undefined !== successCallback) {
                successCallback();
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    updateShowDescriptionOutsideSpine(edition, pathStopId, showDescriptionOutsideSpine, successCallback, errorCallback) {
        const apiResult = PathStopAPI.updateShowDescriptionOutsideSpine(edition.network, pathStopId, showDescriptionOutsideSpine);
        apiResult.then(() => {
            if (undefined !== successCallback) {
                successCallback();
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    delete(edition, pathStopId, successCallback, errorCallback) {
        const apiResult = PathStopAPI.delete(edition.network, pathStopId);
        apiResult.then((_) => {
            if (undefined !== successCallback) {
                const output = {
                    message: "Paragem eliminada com sucesso do Percurso",
                    data: undefined
                };

                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }
}
